<nav class="navbar navbar-expand-lg bg-metronic">
  <div class="container-fluid p-3">
    <!-- Logo -->
    <a class="navbar-brand" routerLink="/dashboard">
      <img [src]="logoUrl" alt="Product Logo" class="logo">
    </a>

    <!-- Mobile toggle -->
    <button class="navbar-toggler" type="button" (click)="mobileCollapsed = !mobileCollapsed" aria-controls="navbarMenu"
      [attr.aria-expanded]="!mobileCollapsed" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Menu items -->
    <div [class.collapse]="mobileCollapsed" class="navbar-collapse" id="navbarMenu">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 navsmain">

        <!-- Dashboard -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/dashboard" routerLinkActive="active"
            [ngClass]="{'active': activeTab === 'dashboard'}">Dashboard</a>
        </li>

        <!-- Clients submenu -->
        <li class="nav-item nav-dropdown" [class.open]="isOpen['clients']" [class.active]="router.url.startsWith('/user') ||
      router.url.startsWith('/client-directory') ||
      router.url.startsWith('/client-offer') ||
      router.url.startsWith('/coupon-code')">
          <button class="nav-link has-children" type="button" (click)="toggleSubmenu($event, 'clients')"
            (keydown.enter)="toggleSubmenu($event, 'clients')" (keydown.space)="toggleSubmenu($event, 'clients')"
            [attr.aria-expanded]="isOpen['clients']" aria-haspopup="true">
            Clients
            <img src="assets/image/down.png" alt="arrow" class="down-arrow" aria-hidden="true">
          </button>

          <ul class="submenu" *ngIf="isOpen['clients']">
            <li><a class="dropdown-item" routerLink="/user" routerLinkActive="active">Client</a></li>
            <li><a class="dropdown-item" routerLink="/client-directory" routerLinkActive="active">Client Directory</a>
            </li>
            <li><a class="dropdown-item" routerLink="/client-offer" routerLinkActive="active">Client Offers</a></li>
            <li><a class="dropdown-item" routerLink="/coupon-code" routerLinkActive="active">Coupons</a></li>
          </ul>
        </li>

        <!-- Transactions -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/transaction" routerLinkActive="active"
            [ngClass]="{'active': activeTab === 'transaction'}">Transactions</a>
        </li>

        <!-- Maintenance -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/maintenance" routerLinkActive="active"
            [ngClass]="{'active': activeTab === 'maintenance'}">Maintenance</a>
        </li>

        <!-- Logs submenu -->
        <li class="nav-item nav-dropdown" [class.open]="isOpen['logs']" [class.active]="router.url.startsWith('/log-in-log') ||
      router.url.startsWith('/error-log')">
          <button class="nav-link has-children" (click)="toggleSubmenu($event, 'logs')"
            (keydown.enter)="toggleSubmenu($event, 'logs')" [attr.aria-expanded]="isOpen['logs']">
            Logs
            <img src="assets/image/down.png" alt="arrow" class="down-arrow" aria-hidden="true">
          </button>

          <ul class="submenu" *ngIf="isOpen['logs']">
            <li><a class="dropdown-item" routerLink="/log-in-log" routerLinkActive="active">Login Logs</a></li>
            <li><a class="dropdown-item" routerLink="/error-log" routerLinkActive="active">Error Logs</a></li>
          </ul>
        </li>

        <!-- Reports -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/reports" routerLinkActive="active"
            [ngClass]="{'active': activeTab === 'reports'}">Reports</a>
        </li>
      </ul>
      <!-- Right-side user section -->
      <ul class="navbar-nav ms-auto">
        <li class="nav-item d-flex align-items-center">
          <div class="itemlastr">
            <h6 class="text-muted mt-3">Hi, {{ username?.FirstName }} {{ username?.LastName }}</h6>

            <div class="dropdown-container">
              <a class="nav-link p-0" href="#" (click)="$event.preventDefault(); isDropdownOpen = !isDropdownOpen"
                aria-haspopup="true" [attr.aria-expanded]="isDropdownOpen">
                <img src="./assets/image/signout-icon.png" alt="signout" class="signout">
              </a>

              <ul class="dropdown-menu dropdown-menu-end" *ngIf="isDropdownOpen">
                <li><a class="dropdown-item" routerLink="/setting">Settings</a></li>
                <li><a class="dropdown-item logout-item" (click)="onLogout()">Logout</a></li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>